import { useMutation, useQueryClient } from "react-query";
import { RestError } from "../../services/rest-service/RestService";
import { IEditUserDTO } from "../../services/user-role-administration-service/Models";
import UserRoleAdministrationService from "../../services/user-role-administration-service/UserRoleAdministrationService";
import { BaseUseMutationParameters } from "../BaseUseMutationParameters";
import { UserMutationContextType } from "./Common";
import { keys } from "./Keys";
import { keys as recipientKeys } from "../recipients/Keys";
import { keys as customizationKeys } from "../ui-customization/Keys";

export type UseSaveUserParameters = {
    groupID: number;
    organizationID: number;
} & BaseUseMutationParameters<IEditUserDTO, IEditUserDTO>;

export function useSaveUser({
    groupID,
    organizationID,
    onError,
    onSuccess
}: UseSaveUserParameters) {
    const queryClient = useQueryClient();

    return useMutation<IEditUserDTO, RestError, IEditUserDTO, UserMutationContextType>(
        (user) => {
            return user.id > -1
                ? UserRoleAdministrationService.putUser(groupID, organizationID, user.id, user)
                : UserRoleAdministrationService.postUser(groupID, organizationID, user);
        },
        {
// not a great idea - membership and security sections won't work because there isn't an id
// available until the cache is refreshed            
            // onMutate: async (user: IEditUserDTO) => {

            //     await queryClient.cancelQueries(keys.all);

            //     const previousUsers = queryClient.getQueryData<UserAndRoleAdministrationUsers>(
            //         keys.userList(
            //             organizationID
            //         )
            //     );
            //     queryClient.setQueryData<UserAndRoleAdministrationUsers>(
            //         keys.userList(
            //             organizationID
            //         ),
            //         (old: UserAndRoleAdministrationUsers | undefined) => {

            //             const users = old?.users;

            //             const existingUser = users?.find(u => u.id === user.id);

            //             const newModel: UserAndRoleAdministrationUser = {
            //                 id: user.id,
            //                 login: user.login,
            //                 lastName: user.lastName,
            //                 firstName: user.firstName,
            //                 jobDescription: user.jobTitle,
            //                 isDisabled: user.isDisabled,
            //                 isMobileAccessEnabled: user.isMobileAccessEnabled,
            //                 lastLoginIPAddress: undefined,
            //                 lastLoginTimestamp: undefined,
            //                 lastActivityTimestamp: undefined,
            //                 isElynxAdmin: undefined,
            //                 isLoggedInUser: undefined
            //             };

            //             if (old) {

            //                 const copy: UserAndRoleAdministrationUsers = {
            //                     ...old,
            //                     users: existingUser
            //                         ? users?.map(u => (u.id === user.id ? newModel : u)) ?? []
            //                         : [...users ?? [], newModel]
            //                 };

            //                 return copy;

            //             } else {

            //                 return {
            //                     users: [newModel],
            //                     // features: {
            //                     //     // something just doesn't seem right here                                    
            //                     //     sendNewUserWelcomeMessage: true,
            //                     //     allowVoiceAlarms: true,
            //                     //     allowSSO: false
            //                     // }
            //                 };
            //             }
            //         }
            //     );

            //     return {
            //         previousUsers: previousUsers
            //     };
            // },
            onError: onError,
            onSuccess: onSuccess,
            onSettled: (_data, error, user, context) => {

                // if (error && context?.previousUsers) {
                //     queryClient.setQueryData<UserAndRoleAdministrationUsers>(
                //         keys.userList(
                //             organizationID
                //         ),
                //         context?.previousUsers
                //     );
                // }

                // If there was an error in saving our user, such as name in use,
                // then don't invalidate the queries, otherwise the user will
                // reload and our changes will be discarded.
                if (!error) {
                    queryClient.invalidateQueries(keys.userLists());
                    queryClient.invalidateQueries(keys.userMembership(user.id));
                    queryClient.invalidateQueries(keys.effectiveUserPermissionList(organizationID, user.id));
                    queryClient.invalidateQueries(keys.roleMemberships());
                    queryClient.invalidateQueries(recipientKeys.usageLists());
                    queryClient.invalidateQueries(customizationKeys.userSettings(user.id));
                    queryClient.invalidateQueries(customizationKeys.userEffectiveSettings(user.id));
                    queryClient.invalidateQueries(customizationKeys.presetList(organizationID));
                    queryClient.invalidateQueries(customizationKeys.presets());
                    queryClient.invalidateQueries(customizationKeys.presetsUserLists());
                }
            }
        }
    );
}
